var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.958 6.417c0-1.013-.82-1.834-1.833-1.834h-8.248c.037 0 .025-.014-.056-.112l-.072-.089c-.028-.034-.107-.136-.176-.225l-.111-.143c-.657-.828-1.31-1.264-2.337-1.264h-5.5c-1.012 0-1.833.82-1.833 1.833v12.834c0 1.012.82 1.833 1.833 1.833h16.5c1.013 0 1.833-.82 1.833-1.833v-11zm-1.833 0v11h-16.5V4.583h5.5c.352 0 .557.137.9.57l.08.103c.074.095.175.226.217.277.461.572.89.88 1.548.884h8.255z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 12.133v2.593l-3.398-3.398 1.296-1.296 2.102 2.101zM11.875 12.133v2.593l3.398-3.398-1.296-1.296-2.102 2.101z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/icons/media-download-icon-41ae52bd.svg";
export { SvgMediaDownloadIcon as ReactComponent };